(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SELECTOR = '.cb-reveal:not(.cb-split-section)';

  function isIntersecting(el) {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom > 0 && rect.top < vh;
  }

  function reveal(el) {
    el.classList.remove('cb-reveal--hidden');
    el.classList.add('cb-reveal--visible');
  }

  function initElement(el) {
    if (el.dataset.cbRevealInit === 'true') return;
    el.dataset.cbRevealInit = 'true';

    if (isIntersecting(el)) {
      reveal(el);
      return;
    }

    el.classList.add('cb-reveal--hidden');
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '80px 0px', threshold: 0 }
    );

    function observeNew(root = document) {
      root.querySelectorAll(SELECTOR).forEach((el) => {
        if (el.dataset.cbRevealInit === 'true') return;
        initElement(el);
        if (!el.classList.contains('cb-reveal--visible')) {
          observer.observe(el);
        }
      });
    }

    observeNew();
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) observeNew(event.target);
    });
  } else {
    const revealAll = () => {
      document.querySelectorAll(SELECTOR).forEach((el) => {
        if (isIntersecting(el)) reveal(el);
      });
    };

    document.querySelectorAll(SELECTOR).forEach(initElement);
    revealAll();
    window.addEventListener('scroll', revealAll, { passive: true });
    window.addEventListener('resize', revealAll);
  }
})();
